/**
 * @file index.tsx
 *
 * @fileoverview Renders a list of errors from a content response.
 */

import React from 'react';
import { MessageAlert } from '~/vcl/atoms/02-messages/01-alert';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { ScrollToElement } from '~/vcl/atoms/06-layout/11-scroll-to-element';
import { WYSIWYGText } from '~/vcl/atoms/13-text/02-WYSIWYG';

export interface ErrorMessage {
  message: string;
}

interface ContentErrorListProps {
  /**
   * The list of error messsages returned from a ContentResponse.
   */
  errors: ErrorMessage[];
  /**
   * Event to call when closing the message.
   */
  onClose?: () => void;
  /**
   * Skips scrolling to the error message.
   *
   * @default "false"
   */
  skipScrolling?: boolean;
}

export const ContentErrorList = ({
  errors,
  onClose,
  skipScrolling = false,
}: ContentErrorListProps) => {
  const ScrollToElementOverride = skipScrolling ? 'div' : ScrollToElement;

  return (
    <ScrollToElementOverride>
      <MessageAlert onClose={onClose} type="assertive" alertStyle="danger">
        <ul>
          {errors.map((error, index) => {
            return (
              <li key={index}>
                <WYSIWYGText
                  format="filtered_html"
                  content={decodeURIComponent(
                    error.message.replace(/\+/g, ' '),
                  )}
                />
              </li>
            );
          })}
        </ul>
      </MessageAlert>
      <Spacing size="medium" />
    </ScrollToElementOverride>
  );
};
